<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit segment</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                Editing of the {{ this.segment.name }} segment {{ civil_status }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="segment name" v-model="name" name="name"
                                    type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="min age" v-model.number="min_age" name="min_age"
                                    type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="max age" v-model.number="max_age" name="max_age"
                                    type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols=" 12" sm="6" md="4">
                                <v-select dense color="primary" label="dominant gender" v-model="gender"
                                    :items="DOMINANT_GENDER" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="month's income" v-model="income"
                                    :items="INCOME_RANGE" name="income" type="text" :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="typical education level" v-model="education"
                                    :items="EDUCATION" name="education" type="text" :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="civil status" v-model="civil_status"
                                    :items="CIVIL_STATUS" name="civil_status" type="text" :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="job" v-model="job" name="job" type="text"
                                    :items="WORKPLACE" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="lifestyle" v-model="lifestyle" name="lifestyle"
                                    :items="LIFESTYLE" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="motiv level" v-model.number="motiv_level"
                                    name="motiv" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="peak size" v-model.number="peakSize"
                                    name="peakSize" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea dense counter rows="4" outlined auto-grow color="primary" label="segment description"
                                    v-model="description" :rules="[rules.required]" @change="onceMore()">
                                </v-textarea>
                            </v-col>

                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!haveBeenChanged || Boolean(error)"
                    @click="editSegment">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'EditSegment',
    props: ['segment'],
    data() {
        return {
            dialog: false,
            valid: false,
            haveBeenChanged: false,
            error: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            name: this.segment.segment?.name,
            min_age: this.segment.segment?.typical_age[0],
            max_age: this.segment.segment?.typical_age[1],
            gender: this.segment.segment?.gender.trim(),
            income: this.segment.segment?.income,
            education: this.segment.segment?.education,
            civil_status: this.segment.segment?.civil_status.trim(),
            job: this.segment.segment?.job,
            lifestyle: this.segment.segment?.lifestyle.trim(),
            motiv_level: this.segment.segment?.motiv_level,
            description: this.segment.segment?.description.trim(),
            peakSize: this.segment.segment.peak_size,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        DOMINANT_GENDER() {
            return this.$store.getters.DOMINANT_GENDER;
        },
        INCOME_RANGE() {
            return this.$store.getters.INCOME_RANGE;
        },
        EDUCATION() {
            return this.$store.getters.EDUCATION;
        },
        CIVIL_STATUS() {
            return this.$store.getters.CIVIL_STATUS;
        },
        WORKPLACE() {
            return this.$store.getters.WORKPLACE;
        },
        LIFESTYLE() {
            return this.$store.getters.LIFESTYLE;
        },
    },
    methods: {

        onceMore() {
            this.error = '';
            this.haveBeenChanged = true;
        },
        async editSegment() {

            if (this.$refs.form.validate() && this.haveBeenChanged) {
            // segment == market-segment 
            const age = [];
            age[0] = this.min_age;
            age[1] = this.max_age;

                const segment = {
                    id: this.segment.id,
                    segmentId: this.segment.segmentId,
                    category: this.segment.segment.category,
                    name: this.name,
                    typical_age: age,
                    gender: this.gender,
                    income: this.income,
                    education: this.education,
                    civil_status: this.civil_status,
                    job: this.job,
                    lifestyle: this.lifestyle,
                    peak_size: this.peakSize,
                    motiv_level: this.motiv_level,
                    description: this.description
                }

                try {
                    //edit segment parameters
                    await this.$store.dispatch('editSegment', segment)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false
            this.error = ''
            this.haveBeenChanged = false;

            this.name = this.segment.segment.name;
            this.peakSize = this.segment.segment.peak_size;
            this.min_age = this.segment.segment?.typical_age[0];
            this.max_age = this.segment.segment?.typical_age[1];
            this.gender = this.segment.segment?.gender.trim();
            this.income = this.segment.segment?.income;
            this.education = this.segment.segment?.education;
            this.civil_status = this.segment.segment?.civil_status.trim();
            this.job = this.segment.segment?.job;
            this.lifestyle = this.segment.segment?.lifestyle.trim();
            this.motiv_level = this.segment.segment?.motiv_level;
            this.description = this.segment.segment?.description.trim();
            
        }
    }
}
</script>